import React, { useState } from "react";
import "../Components/css/loggin.css";
// import { FiEye } from "react-icons/fi";
import { BsFillPersonFill } from "react-icons/bs";
import { Outlet, useNavigate } from "react-router-dom";
import Body from "./Body";
import Footer from "./Footer";
import "../Components/css/responsive.css";
import Navbar from "./Navbar";
import { db, auth } from "./FireBaseConfig";
import { doc, setDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import { motion } from "framer-motion";

const SignUp = () => {
  const [data, setData] = useState({
    firstName: "",
    lastName: "",
  });

  const { firstName, lastName } = data;
  let { uid } = auth.currentUser;
  console.log(uid);
  let navigate = useNavigate();

  const valuesChange = (event) => {
    setData({
      ...data,
      [event.target.name]: event.target.value,
    });
  };

  const SaveData = async (e) => {
    e.preventDefault();
    if (firstName !== "" && lastName !== "") {
      try {
        let res = await setDoc(doc(db, "users", uid), {
          firstName,
          lastName,
        });
        navigate("/signUpPhase2");
        console.log(res);
      } catch (error) {
        console.log(error.code);
        if (error.code)
          return toast.error(error.code, {
            position: "top-center",
          });
      }
    } else if (firstName == "" || lastName == "") {
      toast.error("Please Enter Feild!!");
    }
  };

  return (
    <>
      <Navbar />
      <div className="main-containerr bgclr pt-5 pb-5">
        <div className="container-fluid pb-5">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-7">
              <Body />
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-5">
              <motion.div
                className="main-form mt-5 "
                animate={{
                  x: 0,
                  rotate: 0,
                  scale: 1,
                }}
                initial={{ scale: 1, x: 100 }}
                transition={{ duration: 0.8, delay: 0.3 }}
              >
                <div>
                  <div className="Info text-white">
                    <h3 className=" text-white mb-3">RAFFLE MANIA</h3>
                    <p>Sign Up</p>
                    <form
                      className="formInputs mt-4"
                      onSubmit={() => {
                        navigate(`/SignUpPhase2`);
                      }}
                    >
                      <label>FIRST NAME</label>
                      <div className="form-group d-flex">
                        <input
                          required
                          type="text"
                          placeholder="Enter First Name"
                          id="email"
                          value={firstName}
                          onChange={valuesChange}
                          name="firstName"
                        />
                        <div class="input-group-append">
                          <span class="input-group-text">
                            <BsFillPersonFill />
                          </span>
                        </div>
                      </div>

                      <label>LAST NAME</label>
                      <div className="form-group d-flex">
                        <input
                          required
                          type="text"
                          placeholder="Enter Last Name"
                          id="pwd"
                          value={lastName}
                          onChange={valuesChange}
                          name="lastName"
                        />
                        <div class="input-group-append">
                          <span class="input-group-text">
                            <BsFillPersonFill />
                          </span>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="btnDiv pl-4 pr-5">
                  <button
                    type="submit"
                    className="btn  w-100 signBtn"
                    onClick={SaveData}
                  >
                    Next
                  </button>
                  <p className="text-white p-3">
                    Already Have an Account?
                    <span>
                      <a
                        className="text-primary"
                        onClick={() => {
                          navigate(`/`);
                        }}
                      >
                        Log In
                      </a>
                    </span>
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
      <Footer />

      <Outlet />
    </>
  );
};

export default SignUp;
